module.exports = __webpack_public_path__ + "static/media/project11.98032fc1.jpg";